import { createContext } from 'react';
import { SvgPartRegistry } from './SvgOptimizer';

const contextGlobalKey = '__SvgRegistryContext';

const SvgRegistryContext = createContext<SvgPartRegistry | undefined>(
  undefined
);

export function getSvgRegistryContext() {
  if (!global.tamagoshi) {
    global.tamagoshi = {};
  }

  if (!global.tamagoshi[contextGlobalKey]) {
    global.tamagoshi[contextGlobalKey] = SvgRegistryContext;
  }

  return global.tamagoshi[contextGlobalKey] as typeof SvgRegistryContext;
}
